/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.20.1.0 (NJsonSchema v9.11.0.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { Observable, of as _observableOf, throwError as _observableThrow } from 'rxjs';
import { catchError as _observableCatch, mergeMap as _observableMergeMap } from 'rxjs/operators';
import {
	AssignParentObjectForManyReqDto,
	CreateObjectDto,
	CreateObjectReq,
	EditObjectDto,
	EditObjectReq,
	ErrorResponse,
	GetObjectTypesDto,
	GetObjectsSummaryVm,
	ObjectHistoryDto,
	UnassignParentObjectForManyReqDto,
} from '../models';
import { SwaggerException } from '../utils/swagger-exception';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class ApiService {
	protected jsonParseReviver: (key: string, value: any) => any = undefined;

	private _http: HttpClient;
	private _baseUrl: string;

	constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
		this._http = http;
		this._baseUrl = baseUrl ? baseUrl : '';
	}

	/**
	 * Assign parent object repeatedly for many commands in one http request
	 * @param assignParentObjectReqs (optional) Assign request list (array)
	 * @return Success
	 */
	assignParentObjectForManyRequests(assignParentObjectReqs?: any[]): Observable<AssignParentObjectForManyReqDto> {
		let url_ = this._baseUrl + '/api/objects/parent?';
		if (assignParentObjectReqs !== undefined) {
			assignParentObjectReqs &&
				assignParentObjectReqs.forEach((item, index) => {
					for (const attr in item) {
						if (item.hasOwnProperty(attr)) {
							url_ += 'assignParentObjectReqs[' + index + '].' + attr + '=' + encodeURIComponent('' + (<any>item)[attr]) + '&';
						}
					}
				});
		}
		url_ = url_.replace(/[?&]$/, '');

		const options_: any = {
			observe: 'response',
			responseType: 'blob',
			headers: new HttpHeaders({
				Accept: 'application/json',
			}),
		};

		return this._http
			.request('put', url_, options_)
			.pipe(
				_observableMergeMap((response_: any) => {
					return this.processAssignParentObjectForManyRequests(response_);
				})
			)
			.pipe(
				_observableCatch((response_: any) => {
					if (response_ instanceof HttpResponseBase) {
						try {
							return this.processAssignParentObjectForManyRequests(<any>response_);
						} catch (e) {
							return <Observable<AssignParentObjectForManyReqDto>>(<any>_observableThrow(e));
						}
					} else {
						return <Observable<AssignParentObjectForManyReqDto>>(<any>_observableThrow(response_));
					}
				})
			);
	}

	protected processAssignParentObjectForManyRequests(response: HttpResponseBase): Observable<AssignParentObjectForManyReqDto> {
		const status = response.status;
		const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

		const _headers: any = {};
		if (response.headers) {
			for (const key of response.headers.keys()) {
				_headers[key] = response.headers.get(key);
			}
		}
		if (status === 200) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					let result200: any = null;
					result200 = _responseText === '' ? null : <AssignParentObjectForManyReqDto>JSON.parse(_responseText, this.jsonParseReviver);
					return _observableOf(result200);
				})
			);
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					let result404: any = null;
					result404 = _responseText === '' ? null : <ErrorResponse>JSON.parse(_responseText, this.jsonParseReviver);
					return throwException('A server error occurred.', status, _responseText, _headers, result404);
				})
			);
		} else if (status === 409) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					let result409: any = null;
					result409 = _responseText === '' ? null : <ErrorResponse>JSON.parse(_responseText, this.jsonParseReviver);
					return throwException('A server error occurred.', status, _responseText, _headers, result409);
				})
			);
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					return throwException('An unexpected server error occurred.', status, _responseText, _headers);
				})
			);
		}
		return _observableOf<AssignParentObjectForManyReqDto>(<any>null);
	}

	/**
	 * Unassign from parent object repeatedly for many commands in one http request
	 * @param unassignParentObjectReqs (optional) Request list (array)
	 * @return Success
	 */
	unassignParentObjectForManyRequests(unassignParentObjectReqs?: any[]): Observable<UnassignParentObjectForManyReqDto> {
		let url_ = this._baseUrl + '/api/objects/parent?';
		if (unassignParentObjectReqs !== undefined) {
			unassignParentObjectReqs &&
				unassignParentObjectReqs.forEach((item, index) => {
					for (const attr in item) {
						if (item.hasOwnProperty(attr)) {
							url_ += 'unassignParentObjectReqs[' + index + '].' + attr + '=' + encodeURIComponent('' + (<any>item)[attr]) + '&';
						}
					}
				});
		}
		url_ = url_.replace(/[?&]$/, '');

		const options_: any = {
			observe: 'response',
			responseType: 'blob',
			headers: new HttpHeaders({
				Accept: 'application/json',
			}),
		};

		return this._http
			.request('delete', url_, options_)
			.pipe(
				_observableMergeMap((response_: any) => {
					return this.processUnassignParentObjectForManyRequests(response_);
				})
			)
			.pipe(
				_observableCatch((response_: any) => {
					if (response_ instanceof HttpResponseBase) {
						try {
							return this.processUnassignParentObjectForManyRequests(<any>response_);
						} catch (e) {
							return <Observable<UnassignParentObjectForManyReqDto>>(<any>_observableThrow(e));
						}
					} else {
						return <Observable<UnassignParentObjectForManyReqDto>>(<any>_observableThrow(response_));
					}
				})
			);
	}

	protected processUnassignParentObjectForManyRequests(response: HttpResponseBase): Observable<UnassignParentObjectForManyReqDto> {
		const status = response.status;
		const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

		const _headers: any = {};
		if (response.headers) {
			for (const key of response.headers.keys()) {
				_headers[key] = response.headers.get(key);
			}
		}
		if (status === 200) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					let result200: any = null;
					result200 = _responseText === '' ? null : <UnassignParentObjectForManyReqDto>JSON.parse(_responseText, this.jsonParseReviver);
					return _observableOf(result200);
				})
			);
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					let result404: any = null;
					result404 = _responseText === '' ? null : <ErrorResponse>JSON.parse(_responseText, this.jsonParseReviver);
					return throwException('A server error occurred.', status, _responseText, _headers, result404);
				})
			);
		} else if (status === 405) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					let result405: any = null;
					result405 = _responseText === '' ? null : <ErrorResponse>JSON.parse(_responseText, this.jsonParseReviver);
					return throwException('A server error occurred.', status, _responseText, _headers, result405);
				})
			);
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					return throwException('An unexpected server error occurred.', status, _responseText, _headers);
				})
			);
		}
		return _observableOf<UnassignParentObjectForManyReqDto>(<any>null);
	}

	/**
	 * Get Object by Id
	 * @param objectId Object Id
	 * @return Success
	 */
	getObjectById(objectId: number): Observable<GetObjectsSummaryVm> {
		let url_ = this._baseUrl + '/api/objects/{objectId}';
		if (objectId === undefined || objectId === null) {
			throw new Error("The parameter 'objectId' must be defined.");
		}
		url_ = url_.replace('{objectId}', encodeURIComponent('' + objectId));
		url_ = url_.replace(/[?&]$/, '');

		const options_: any = {
			observe: 'response',
			responseType: 'blob',
			headers: new HttpHeaders({
				Accept: 'application/json',
			}),
		};

		return this._http
			.request('get', url_, options_)
			.pipe(
				_observableMergeMap((response_: any) => {
					return this.processGetObjectById(response_);
				})
			)
			.pipe(
				_observableCatch((response_: any) => {
					if (response_ instanceof HttpResponseBase) {
						try {
							return this.processGetObjectById(<any>response_);
						} catch (e) {
							return <Observable<GetObjectsSummaryVm>>(<any>_observableThrow(e));
						}
					} else {
						return <Observable<GetObjectsSummaryVm>>(<any>_observableThrow(response_));
					}
				})
			);
	}

	protected processGetObjectById(response: HttpResponseBase): Observable<GetObjectsSummaryVm> {
		const status = response.status;
		const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

		const _headers: any = {};
		if (response.headers) {
			for (const key of response.headers.keys()) {
				_headers[key] = response.headers.get(key);
			}
		}
		if (status === 200) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					let result200: any = null;
					result200 = _responseText === '' ? null : <GetObjectsSummaryVm>JSON.parse(_responseText, this.jsonParseReviver);
					return _observableOf(result200);
				})
			);
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					return throwException('An unexpected server error occurred.', status, _responseText, _headers);
				})
			);
		}
		return _observableOf<GetObjectsSummaryVm>(<any>null);
	}

	/**
	 * Edit a Object
	 * @param objectId Object Identifier
	 * @param editObjectReq (optional) MasterDataCommand object
	 * @return Success
	 */
	editObject(objectId: number, editObjectReq?: EditObjectReq): Observable<EditObjectDto> {
		let url_ = this._baseUrl + '/api/objects/{objectId}';
		if (objectId === undefined || objectId === null) {
			throw new Error("The parameter 'objectId' must be defined.");
		}
		url_ = url_.replace('{objectId}', encodeURIComponent('' + objectId));
		url_ = url_.replace(/[?&]$/, '');

		const content_ = JSON.stringify(editObjectReq);

		const options_: any = {
			body: content_,
			observe: 'response',
			responseType: 'blob',
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
			}),
		};

		return this._http
			.request('put', url_, options_)
			.pipe(
				_observableMergeMap((response_: any) => {
					return this.processEditObject(response_);
				})
			)
			.pipe(
				_observableCatch((response_: any) => {
					if (response_ instanceof HttpResponseBase) {
						try {
							return this.processEditObject(<any>response_);
						} catch (e) {
							return <Observable<EditObjectDto>>(<any>_observableThrow(e));
						}
					} else {
						return <Observable<EditObjectDto>>(<any>_observableThrow(response_));
					}
				})
			);
	}

	protected processEditObject(response: HttpResponseBase): Observable<EditObjectDto> {
		const status = response.status;
		const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

		const _headers: any = {};
		if (response.headers) {
			for (const key of response.headers.keys()) {
				_headers[key] = response.headers.get(key);
			}
		}
		if (status === 200) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					let result200: any = null;
					result200 = _responseText === '' ? null : <EditObjectDto>JSON.parse(_responseText, this.jsonParseReviver);
					return _observableOf(result200);
				})
			);
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					let result404: any = null;
					result404 = _responseText === '' ? null : <ErrorResponse>JSON.parse(_responseText, this.jsonParseReviver);
					return throwException('A server error occurred.', status, _responseText, _headers, result404);
				})
			);
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					return throwException('An unexpected server error occurred.', status, _responseText, _headers);
				})
			);
		}
		return _observableOf<EditObjectDto>(<any>null);
	}

	/**
	 * Delete a Object
	 * @param objectId ObjectId
	 * @param forceChildsUnassigment (optional)
	 * @param forceParentsUnassigment (optional)
	 * @param forceChildsDeletion (optional)
	 * @return Success
	 */
	deleteObject(objectId: number, forceChildsUnassigment?: boolean, forceParentsUnassigment?: boolean, forceChildsDeletion?: boolean): Observable<void> {
		let url_ = this._baseUrl + '/api/objects/{objectId}?';
		if (objectId === undefined || objectId === null) {
			throw new Error("The parameter 'objectId' must be defined.");
		}
		url_ = url_.replace('{objectId}', encodeURIComponent('' + objectId));
		if (forceChildsUnassigment !== undefined) {
			url_ += 'forceChildsUnassigment=' + encodeURIComponent('' + forceChildsUnassigment) + '&';
		}
		if (forceParentsUnassigment !== undefined) {
			url_ += 'forceParentsUnassigment=' + encodeURIComponent('' + forceParentsUnassigment) + '&';
		}
		if (forceChildsDeletion !== undefined) {
			url_ += 'forceChildsDeletion=' + encodeURIComponent('' + forceChildsDeletion) + '&';
		}
		url_ = url_.replace(/[?&]$/, '');

		const options_: any = {
			observe: 'response',
			responseType: 'blob',
			headers: new HttpHeaders({}),
		};

		return this._http
			.request('delete', url_, options_)
			.pipe(
				_observableMergeMap((response_: any) => {
					return this.processDeleteObject(response_);
				})
			)
			.pipe(
				_observableCatch((response_: any) => {
					if (response_ instanceof HttpResponseBase) {
						try {
							return this.processDeleteObject(<any>response_);
						} catch (e) {
							return <Observable<void>>(<any>_observableThrow(e));
						}
					} else {
						return <Observable<void>>(<any>_observableThrow(response_));
					}
				})
			);
	}

	protected processDeleteObject(response: HttpResponseBase): Observable<void> {
		const status = response.status;
		const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

		const _headers: any = {};
		if (response.headers) {
			for (const key of response.headers.keys()) {
				_headers[key] = response.headers.get(key);
			}
		}
		if (status === 200) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					return _observableOf<void>(<any>null);
				})
			);
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					let result404: any = null;
					result404 = _responseText === '' ? null : <ErrorResponse>JSON.parse(_responseText, this.jsonParseReviver);
					return throwException('A server error occurred.', status, _responseText, _headers, result404);
				})
			);
		} else if (status === 409) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					let result409: any = null;
					result409 = _responseText === '' ? null : <ErrorResponse>JSON.parse(_responseText, this.jsonParseReviver);
					return throwException('A server error occurred.', status, _responseText, _headers, result409);
				})
			);
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					return throwException('An unexpected server error occurred.', status, _responseText, _headers);
				})
			);
		}
		return _observableOf<void>(<any>null);
	}

	/**
   * Get Objects list
  Available only for high level user roles
   * @param objectTypeId (optional) Object Type Id
   * @param objectTypeName (optional)
   * @param clientIds (optional) Client Ids
   * @param allowParentData (optional)
   * @return Success
   */
	getObjects(objectTypeId?: number, objectTypeName?: string, clientIds?: number[], allowParentData?: boolean): Observable<GetObjectsSummaryVm> {
		let url_ = this._baseUrl + '/api/objects?';
		if (objectTypeId !== undefined) {
			url_ += 'objectTypeId=' + encodeURIComponent('' + objectTypeId) + '&';
		}
		if (objectTypeName !== undefined) {
			url_ += 'objectTypeName=' + encodeURIComponent('' + objectTypeName) + '&';
		}
		if (clientIds !== undefined) {
			clientIds &&
				clientIds.forEach((item) => {
					url_ += 'clientIds=' + encodeURIComponent('' + item) + '&';
				});
		}
		if (allowParentData !== undefined) {
			url_ += 'allowParentData=' + encodeURIComponent('' + allowParentData) + '&';
		}
		url_ = url_.replace(/[?&]$/, '');

		const options_: any = {
			observe: 'response',
			responseType: 'blob',
			headers: new HttpHeaders({
				Accept: 'application/json',
			}),
		};

		return this._http
			.request('get', url_, options_)
			.pipe(
				_observableMergeMap((response_: any) => {
					return this.processGetObjects(response_);
				})
			)
			.pipe(
				_observableCatch((response_: any) => {
					if (response_ instanceof HttpResponseBase) {
						try {
							return this.processGetObjects(<any>response_);
						} catch (e) {
							return <Observable<GetObjectsSummaryVm>>(<any>_observableThrow(e));
						}
					} else {
						return <Observable<GetObjectsSummaryVm>>(<any>_observableThrow(response_));
					}
				})
			);
	}

	protected processGetObjects(response: HttpResponseBase): Observable<GetObjectsSummaryVm> {
		const status = response.status;
		const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

		const _headers: any = {};
		if (response.headers) {
			for (const key of response.headers.keys()) {
				_headers[key] = response.headers.get(key);
			}
		}
		if (status === 200) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					let result200: any = null;
					result200 = _responseText === '' ? null : <GetObjectsSummaryVm>JSON.parse(_responseText, this.jsonParseReviver);
					return _observableOf(result200);
				})
			);
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					return throwException('An unexpected server error occurred.', status, _responseText, _headers);
				})
			);
		}
		return _observableOf<GetObjectsSummaryVm>(<any>null);
	}

	/**
	 * Create a new Object
	 * @param createObjectReq (optional) MasterDataCommand object
	 * @return Success
	 */
	createObject(createObjectReq?: CreateObjectReq): Observable<CreateObjectDto> {
		let url_ = this._baseUrl + '/api/objects';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = JSON.stringify(createObjectReq);

		const options_: any = {
			body: content_,
			observe: 'response',
			responseType: 'blob',
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
			}),
		};

		return this._http
			.request('post', url_, options_)
			.pipe(
				_observableMergeMap((response_: any) => {
					return this.processCreateObject(response_);
				})
			)
			.pipe(
				_observableCatch((response_: any) => {
					if (response_ instanceof HttpResponseBase) {
						try {
							return this.processCreateObject(<any>response_);
						} catch (e) {
							return <Observable<CreateObjectDto>>(<any>_observableThrow(e));
						}
					} else {
						return <Observable<CreateObjectDto>>(<any>_observableThrow(response_));
					}
				})
			);
	}

	protected processCreateObject(response: HttpResponseBase): Observable<CreateObjectDto> {
		const status = response.status;
		const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

		const _headers: any = {};
		if (response.headers) {
			for (const key of response.headers.keys()) {
				_headers[key] = response.headers.get(key);
			}
		}
		if (status === 201) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					let result201: any = null;
					result201 = _responseText === '' ? null : <CreateObjectDto>JSON.parse(_responseText, this.jsonParseReviver);
					return _observableOf(result201);
				})
			);
		} else if (status === 400) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					let result400: any = null;
					result400 = _responseText === '' ? null : <ErrorResponse>JSON.parse(_responseText, this.jsonParseReviver);
					return throwException('A server error occurred.', status, _responseText, _headers, result400);
				})
			);
		} else if (status === 404) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					let result404: any = null;
					result404 = _responseText === '' ? null : <ErrorResponse>JSON.parse(_responseText, this.jsonParseReviver);
					return throwException('A server error occurred.', status, _responseText, _headers, result404);
				})
			);
		} else if (status === 409) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					let result409: any = null;
					result409 = _responseText === '' ? null : <ErrorResponse>JSON.parse(_responseText, this.jsonParseReviver);
					return throwException('A server error occurred.', status, _responseText, _headers, result409);
				})
			);
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					return throwException('An unexpected server error occurred.', status, _responseText, _headers);
				})
			);
		}
		return _observableOf<CreateObjectDto>(<any>null);
	}

	/**
   * Get Objects types list
  Available only for high level roles
   * @param clientIds (optional)
   * @return Success
   */
	getObjectTypes(clientIds?: number[]): Observable<GetObjectTypesDto[]> {
		let url_ = this._baseUrl + '/api/objects/types?';
		if (clientIds !== undefined) {
			clientIds &&
				clientIds.forEach((item) => {
					url_ += 'clientIds=' + encodeURIComponent('' + item) + '&';
				});
		}
		url_ = url_.replace(/[?&]$/, '');

		const options_: any = {
			observe: 'response',
			responseType: 'blob',
			headers: new HttpHeaders({
				Accept: 'application/json',
			}),
		};

		return this._http
			.request('get', url_, options_)
			.pipe(
				_observableMergeMap((response_: any) => {
					return this.processGetObjectTypes(response_);
				})
			)
			.pipe(
				_observableCatch((response_: any) => {
					if (response_ instanceof HttpResponseBase) {
						try {
							return this.processGetObjectTypes(<any>response_);
						} catch (e) {
							return <Observable<GetObjectTypesDto[]>>(<any>_observableThrow(e));
						}
					} else {
						return <Observable<GetObjectTypesDto[]>>(<any>_observableThrow(response_));
					}
				})
			);
	}

	protected processGetObjectTypes(response: HttpResponseBase): Observable<GetObjectTypesDto[]> {
		const status = response.status;
		const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

		const _headers: any = {};
		if (response.headers) {
			for (const key of response.headers.keys()) {
				_headers[key] = response.headers.get(key);
			}
		}
		if (status === 200) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					let result200: any = null;
					result200 = _responseText === '' ? null : <GetObjectTypesDto[]>JSON.parse(_responseText, this.jsonParseReviver);
					return _observableOf(result200);
				})
			);
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					return throwException('An unexpected server error occurred.', status, _responseText, _headers);
				})
			);
		}
		return _observableOf<GetObjectTypesDto[]>(<any>null);
	}

	/**
	 * Get Object history
	 * @param objectId Object Id
	 * @return Success
	 */
	getObjectHistory(objectId: number): Observable<ObjectHistoryDto[]> {
		let url_ = this._baseUrl + '/api/objects/{objectId}/history';
		if (objectId === undefined || objectId === null) {
			throw new Error("The parameter 'objectId' must be defined.");
		}
		url_ = url_.replace('{objectId}', encodeURIComponent('' + objectId));
		url_ = url_.replace(/[?&]$/, '');

		const options_: any = {
			observe: 'response',
			responseType: 'blob',
			headers: new HttpHeaders({
				Accept: 'application/json',
			}),
		};

		return this._http
			.request('get', url_, options_)
			.pipe(
				_observableMergeMap((response_: any) => {
					return this.processGetObjectHistory(response_);
				})
			)
			.pipe(
				_observableCatch((response_: any) => {
					if (response_ instanceof HttpResponseBase) {
						try {
							return this.processGetObjectHistory(<any>response_);
						} catch (e) {
							return <Observable<ObjectHistoryDto[]>>(<any>_observableThrow(e));
						}
					} else {
						return <Observable<ObjectHistoryDto[]>>(<any>_observableThrow(response_));
					}
				})
			);
	}

	protected processGetObjectHistory(response: HttpResponseBase): Observable<ObjectHistoryDto[]> {
		const status = response.status;
		const responseBlob = response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

		const _headers: any = {};
		if (response.headers) {
			for (const key of response.headers.keys()) {
				_headers[key] = response.headers.get(key);
			}
		}
		if (status === 200) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					let result200: any = null;
					result200 = _responseText === '' ? null : <ObjectHistoryDto[]>JSON.parse(_responseText, this.jsonParseReviver);
					return _observableOf(result200);
				})
			);
		} else if (status !== 200 && status !== 204) {
			return blobToText(responseBlob).pipe(
				_observableMergeMap((_responseText) => {
					return throwException('An unexpected server error occurred.', status, _responseText, _headers);
				})
			);
		}
		return _observableOf<ObjectHistoryDto[]>(<any>null);
	}
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any }, result?: any): Observable<any> {
	if (result !== null && result !== undefined) {
		return _observableThrow(result);
	} else {
		return _observableThrow(new SwaggerException(message, status, response, headers, null));
	}
}

function blobToText(blob: any): Observable<string> {
	return new Observable<string>((observer: any) => {
		if (!blob) {
			observer.next('');
			observer.complete();
		} else {
			const reader = new FileReader();
			reader.onload = function () {
				observer.next(this.result);
				observer.complete();
			};
			reader.readAsText(blob);
		}
	});
}
